import { Typography, useTheme } from '@mui/material';
import clsx from 'clsx';

import { useStyles } from './style';
import { isFullString } from '../../../shared/utility';

interface LabelProps {
	children?: React.ReactNode;
	className?: string;
	color?: string;
	shape?: 'square' | 'rounded';
	style?: object;
	variant?: 'contained' | 'outlined';
	fontColor?: string;
	type?: 'success' | 'warning' | 'error' | 'default' | 'disabled';
}

/**
 * Use the chip from the mui library
 */
const Label = ({
	className,
	variant = 'contained',
	color,
	shape = 'rounded',
	children,
	style = {},
	fontColor,
	type = 'default',
	...rest
}: LabelProps) => {
	const classes = useStyles();
	const theme = useTheme();

	const rootClassName = clsx(
		{
			[classes.root]: true,
			[classes.rounded]: shape === 'rounded',
		},
		className
	);

	const colorVariants = {
		success: {
			backgroundColor: theme.palette.success.light,
			color: theme.palette.success.main,
		},
		warning: {
			backgroundColor: theme.palette.warning.light,
			color: theme.palette.warning.main,
		},
		error: {
			backgroundColor: theme.palette.error.light,
			color: theme.palette.error.main,
		},
		default: {
			backgroundColor: theme.palette.info.light,
			color: theme.palette.info.main,
		},
		disabled: {
			backgroundColor: theme.palette.disabled.light,
			color: theme.palette.disabled.main,
		},
	};

	const finalStyle = { ...style };

	if (variant === 'contained') {
		finalStyle.backgroundColor =
			isFullString(color) ? color
			: isFullString(type) ? colorVariants[type].backgroundColor
			: colorVariants.default.backgroundColor;
		finalStyle.color =
			isFullString(fontColor) ? fontColor
			: isFullString(type) ? colorVariants[type].color
			: colorVariants.default.color;
	} else {
		finalStyle.border = `1px solid ${
			isFullString(color) ? color
			: isFullString(type) ? colorVariants[type].color
			: colorVariants.default.color
		}`;
		finalStyle.color =
			isFullString(color) ? color
			: isFullString(type) ? colorVariants[type].color
			: colorVariants.default.color;
	}

	return (
		<Typography {...rest} className={rootClassName} style={finalStyle}>
			{children}
		</Typography>
	);
};

export default Label;
